import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SectionLabel, FadeUp } from "../site/motion";

const TEXT = "Skaris is a lean, delivery-focused IT services firm. We work directly with you — from requirements through deployment and post-launch support — without the overhead of a large agency, and price every project on a fixed, phased basis.";

const Word = ({ w, i, total, progress }) => {
  const start = i / total;
  const opacity = useTransform(progress, [start, start + 2 / total], [0.32, 1]);
  return <motion.span style={{ opacity }} className="mr-[0.25em] inline-block">{w}</motion.span>;
};

const STATS = [
  { v: "End-to-end", l: "Architecture → support" },
  { v: "Fixed", l: "Phased pricing" },
  { v: "Direct", l: "No account-manager relay" },
];

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const words = TEXT.split(" ");
  return (
    <section data-testid="manifesto-section" className="relative py-28 md:py-40">
      <div className="mx-auto grid max-w-[1440px] gap-12 px-6 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-3"><SectionLabel n="(01)">Who we are</SectionLabel></div>
        <div className="lg:col-span-9">
          <p ref={ref} className="font-display text-3xl font-medium leading-[1.15] tracking-[-0.02em] text-cream md:text-5xl">
            {words.map((w, i) => <Word key={i} w={w} i={i} total={words.length} progress={scrollYProgress} />)}
          </p>
          <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-cream/10 bg-cream/10 sm:grid-cols-3">
            {STATS.map((s, i) => (
              <FadeUp key={s.l} delay={i * 0.08} className="bg-skaris-ink p-7">
                <p className="font-display text-3xl font-semibold text-cream">{s.v}</p>
                <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.2em] text-cream/60">{s.l}</p>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
